var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { BuildertrendLinkApi, BuildertrendUnlinkApi, } from '../api/b2b/buildertrend';
import { GetLocalDeliveriesAPI, GetOrderDetailsAPI, GetOrderHistoryAPI, qbCountAPI, } from '../api/oms/order-history';
import { GetBigReceiptAPI } from '../api/oms/receipt';
import { instoreOrderNumberFormat } from '../components/shared/order-number-formatter/OrderNumberFormatter';
import { FeatureSwitches } from '../constants/feature-switches';
import { ERR_GENERIC } from '../constants/response-error-messages';
import { pushErrorEvent } from '../utils/analytics';
import { createTimeStamp } from '../utils/date-utils';
import { openFile, parseBlob } from '../utils/http-helper';
import { getOrderType } from '../utils/order-history/card-utils';
import { setNoRecordsFoundError, setPurchaseHistoryPageError, } from '../utils/purchase-history/analytics';
import { getSvocId, getUserId } from '../utils/user';
import { useCommonContext, useExperienceContext } from './useContexts';
export var OrderHistoryPoJobNameHooks = function () {
    var _a = useState(''), poJobNameState = _a[0], setPoJobNameState = _a[1];
    return { poJobNameState: poJobNameState, setPoJobNameState: setPoJobNameState };
};
export var OrderHistoryModalHooks = function () {
    var _a = useState(false), openModal = _a[0], setOpenModal = _a[1];
    var _b = useState(null), orderHistoryModalComponent = _b[0], setOrderHistoryModalComponent = _b[1];
    return {
        openModal: openModal,
        setOpenModal: setOpenModal,
        orderHistoryModalComponent: orderHistoryModalComponent,
        setOrderHistoryModalComponent: setOrderHistoryModalComponent,
    };
};
export var GetLocalDeliveryData = function (requestData) {
    var _a = useState(undefined), localDeliveryData = _a[0], setLocalDeliveryData = _a[1];
    var _b = useState(undefined), localDeliveryError = _b[0], setLocalDeliveryError = _b[1];
    var _c = useState(false), localDeliveryLoaded = _c[0], setLocalDeliveryLoaded = _c[1];
    var wrappedRequest = { orderHistoryRequest: requestData };
    useEffect(function () {
        GetLocalDeliveriesAPI(wrappedRequest)
            .then(function (response) {
            if (response.data.orderCount === 0)
                setNoRecordsFoundError();
            setLocalDeliveryData(response.data);
        })
            .catch(function (error) {
            // setPurchaseHistoryPageError(error);
            setLocalDeliveryError(error);
        })
            .finally(function () {
            setLocalDeliveryLoaded(true);
        });
        return function () {
            setLocalDeliveryLoaded(false);
        };
    }, [requestData.startDate, requestData.endDate, requestData.pageNumber]);
    return {
        localDeliveryData: localDeliveryData,
        localDeliveryError: localDeliveryError,
        localDeliveryLoaded: localDeliveryLoaded,
    };
};
export var GetOrderHistoryData = function (requestData) {
    var channel = useExperienceContext().channel;
    var _a = useState(undefined), orderHistoryData = _a[0], setOrderHistoryData = _a[1];
    var _b = useState(undefined), orderHistoryError = _b[0], setOrderHistoryError = _b[1];
    var _c = useState(false), orderHistoryLoaded = _c[0], setOrderHistoryLoaded = _c[1];
    var _d = useState(undefined), cpsDataSource = _d[0], setCPSDataSource = _d[1];
    var wrappedRequest = { orderHistoryRequest: requestData };
    useEffect(function () {
        GetOrderHistoryAPI(wrappedRequest, channel)
            .then(function (response) {
            if (response.data.orderCount === 0)
                setNoRecordsFoundError();
            setOrderHistoryData(response.data);
            setCPSDataSource(response.headers.datasource);
        })
            .catch(function (error) {
            var _a, _b;
            setPurchaseHistoryPageError(error);
            setOrderHistoryError(error);
            setCPSDataSource((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.datasource);
        })
            .finally(function () {
            setOrderHistoryLoaded(true);
        });
        return function () {
            setOrderHistoryError(undefined);
            setOrderHistoryLoaded(false);
        };
    }, [
        requestData.startDate,
        requestData.endDate,
        requestData.pageNumber,
        requestData.sortBy,
        requestData.sortOrder,
        requestData.resultsFilter,
        requestData.searchBy,
    ]);
    return {
        orderHistoryData: orderHistoryData,
        orderHistoryError: orderHistoryError,
        orderHistoryLoaded: orderHistoryLoaded,
        cpsDataSource: cpsDataSource,
    };
};
export var GetBigReceiptHook = function (encryptedBigReceiptRequest, setAlertState) {
    var userId = getUserId() || '';
    var svocId = getSvocId() || '';
    var encryptedRequest = {
        userId: userId,
        customerAccountId: svocId,
        encryptedBigReceiptRequest: encryptedBigReceiptRequest,
    };
    var omsEncryptedRequest = {
        userId: userId,
        customerAccountId: svocId,
        encryptedBigReceiptRequest: encryptedBigReceiptRequest,
    };
    var receiptEncryptedRequest = FeatureSwitches.OMS_VIEW_BIG_RECEIPT_SWITCH
        ? omsEncryptedRequest
        : encryptedRequest;
    GetBigReceiptAPI(receiptEncryptedRequest)
        .then(function (response) {
        setAlertState({
            alertTitle: 'Success',
            alertMessage: "Big Receipt has been successfully exported.\n      Please check your browser downloads folder for the file.",
            status: 'success',
        });
        var blob = parseBlob(response.data, 'data:application/pdf,');
        var fileName = "Order_Invoice".concat(createTimeStamp(), ".pdf");
        openFile(blob, fileName);
    })
        .catch(function (error) {
        var _a, _b;
        var statusCode = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status.toString()) || '';
        var statusMessage = ((_b = error.response) === null || _b === void 0 ? void 0 : _b.statusText) || '';
        pushErrorEvent('purchase history', statusCode, statusMessage, 'inline');
        setAlertState({
            alertTitle: 'Failed',
            alertMessage: ERR_GENERIC.message,
            status: 'error',
        });
    })
        .finally(function () {
        // Put trigger to end loading state
    });
};
/**
 * Purchase History Page Header Hooks s
 */
export var ConnectBuildertrendAccount = function (code, BtApiState, setBtApiState) {
    /**
     * btResponseObj - Holds the response data for either postive or negitive outcomes
     * On Postive: fed devs do not have to show any response data, just UX
     * On Negitive: fed devs need to show error in some way to user.
     */
    var btResponseObj;
    setBtApiState(__assign(__assign({}, BtApiState), { isLoading: true }));
    BuildertrendLinkApi(code)
        .then(function () {
        btResponseObj = { linked: true };
    })
        .catch(function (error) {
        // Just returns the errorCode, mapper function will generate message
        var _a;
        /*   AnalyticsService.setErrorEvent({
          type: 'error',
          displayType: 'inline',
          pageSection: 'buildertrend',
          message: btResultMessage,
          code: btResultCode,
        }); */
        btResponseObj = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || {
            errors: [
                {
                    errorCode: 'DEFAULT',
                    errorMessage: 'We’re sorry, there was a temporary technical error linking accounts. Please close this window and retry by clicking Link Buildertrend again or contact customer support if you continue to receive this error.',
                },
            ],
        };
    })
        .finally(function () {
        return setBtApiState({ isLoading: false, btResponse: btResponseObj });
    });
};
export var DisconnectBuildertrendAccount = function (requestType, _BtApiState, setBtApiState) {
    /**
     * btResponseObj - Holds the response data for either postive or negitive outcomes
     * On Postive: fed devs do not have to show any response data, just UX
     * On Negitive: fed devs need to show error in some way to user.
     */
    var btResponseObj;
    BuildertrendUnlinkApi(requestType)
        .then(function () {
        btResponseObj = { unlinked: true };
    })
        .catch(function (error) {
        // Just returns the errorCode, mapper function will generate message
        var _a;
        /*   AnalyticsService.setErrorEvent({
          type: 'error',
          displayType: 'inline',
          pageSection: 'buildertrend',
          message: btResultMessage,
          code: btResultCode,
        }); */
        btResponseObj = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || {
            errors: [
                {
                    errorCode: 'DEFAULT',
                    errorMessage: 'We’re sorry, there was a temporary technical error linking accounts. Please close this window and retry by clicking Link Buildertrend again or contact customer support if you continue to receive this error.',
                },
            ],
        };
    })
        .finally(function () {
        return setBtApiState({
            isLoading: false,
            btResponse: btResponseObj,
        });
    });
};
/**
 * QuickBooks Hooks
 */
export var GetQBOrderCount = function (request, openModal) {
    var _a = useState(), qbOrderCount = _a[0], setQBOrderCount = _a[1];
    var wrappedRequest = { orderHistoryRequest: request };
    useEffect(function () {
        if (openModal) {
            qbCountAPI(wrappedRequest)
                .then(function (response) {
                setQBOrderCount(response.data.orderCount);
            })
                .catch(function () {
                setQBOrderCount(undefined);
            });
        }
    }, [openModal, request.startDate, request.endDate]);
    return qbOrderCount;
};
/**
 * Purchase Histroy hooks for getting order details apis
 * This is unused
 */
export var GetOrderDetailsData = function (orderHistoryData, orderHistoryLoaded, customerType, customerRole, dateSelectorValue) {
    var _a = useState([]), orderDetailsData = _a[0], setOrderDetailsData = _a[1];
    var _b = useState(null), orderDetailsError = _b[0], setOrderDetailsError = _b[1];
    var _c = useState(false), orderDetailsLoaded = _c[0], setOrderDetailsLoaded = _c[1];
    var timezone = useCommonContext().timezone;
    var orderDetailsAPICall = function (orderDetailsRequest) { return __awaiter(void 0, void 0, void 0, function () {
        var responses;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(orderDetailsRequest === null || orderDetailsRequest === void 0 ? void 0 : orderDetailsRequest.map(getOrderDetails))];
                case 1:
                    responses = _a.sent();
                    return [2 /*return*/, responses];
            }
        });
    }); };
    var getOrderDetails = function (requestData) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, status_1, headers, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, 5, 6]);
                    return [4 /*yield*/, GetOrderDetailsAPI(requestData, customerType, customerRole)];
                case 1:
                    _a = _b.sent(), data = _a.data, status_1 = _a.status, headers = _a.headers;
                    if (!(status_1 === 200)) return [3 /*break*/, 3];
                    data.traceId = headers === null || headers === void 0 ? void 0 : headers.traceid;
                    return [4 /*yield*/, data];
                case 2: return [2 /*return*/, _b.sent()];
                case 3: return [2 /*return*/, null];
                case 4:
                    error_1 = _b.sent();
                    setOrderDetailsError(error_1);
                    return [2 /*return*/, null];
                case 5:
                    setOrderDetailsLoaded(true);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        if (orderHistoryLoaded &&
            (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) &&
            ((_a = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var orderDetailsRequest = [];
            for (var i = 0; i < 20; i += 1) {
                if (((_d = (_c = (_b = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _b === void 0 ? void 0 : _b[i]) === null || _c === void 0 ? void 0 : _c.orderNumbers) === null || _d === void 0 ? void 0 : _d[0]) &&
                    (customerType === 'b2b' ||
                        (customerType === 'b2c' &&
                            ((_f = (_e = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _e === void 0 ? void 0 : _e[i]) === null || _f === void 0 ? void 0 : _f.orderOrigin) !== 'online'))) {
                    var _w = (_h = (_g = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _g === void 0 ? void 0 : _g[i]) !== null && _h !== void 0 ? _h : {}, orderNumbers = _w.orderNumbers, salesDate = _w.salesDate, storeNumber = _w.storeNumber, transactionId = _w.transactionId, registerNumber = _w.registerNumber, transactionType = _w.transactionType;
                    var parsedOrderNumbers = void 0;
                    if ((_j = orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) === null || _j === void 0 ? void 0 : _j.includes(',')) {
                        parsedOrderNumbers = (_l = [(_k = orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) === null || _k === void 0 ? void 0 : _k.split(',')]) === null || _l === void 0 ? void 0 : _l.flat();
                    }
                    else if ((orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) === 'undefined') {
                        parsedOrderNumbers = [
                            instoreOrderNumberFormat(registerNumber, transactionId),
                        ];
                    }
                    else {
                        parsedOrderNumbers = orderNumbers;
                    }
                    var requestData = generateRequestData(customerType, parsedOrderNumbers !== null && parsedOrderNumbers !== void 0 ? parsedOrderNumbers : [], timezone, registerNumber, salesDate, storeNumber, transactionId, transactionType);
                    orderDetailsRequest === null || orderDetailsRequest === void 0 ? void 0 : orderDetailsRequest.push(requestData);
                }
                if (((_p = (_o = (_m = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _m === void 0 ? void 0 : _m[i]) === null || _o === void 0 ? void 0 : _o.orderNumbers) === null || _p === void 0 ? void 0 : _p[0]) &&
                    customerType !== 'b2b' &&
                    ((_r = (_q = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _q === void 0 ? void 0 : _q[i]) === null || _r === void 0 ? void 0 : _r.orderOrigin) === 'online') {
                    var orderNumbers = ((_t = (_s = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _s === void 0 ? void 0 : _s[i]) !== null && _t !== void 0 ? _t : {}).orderNumbers;
                    var parsedOrderNumbers = (orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0].includes(','))
                        ? (_v = [(_u = orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) === null || _u === void 0 ? void 0 : _u.split(',')]) === null || _v === void 0 ? void 0 : _v.flat()
                        : orderNumbers;
                    var requestData = generateRequestData(customerType, parsedOrderNumbers !== null && parsedOrderNumbers !== void 0 ? parsedOrderNumbers : [], timezone);
                    orderDetailsRequest === null || orderDetailsRequest === void 0 ? void 0 : orderDetailsRequest.push(requestData);
                }
                if (i === 20) {
                    break;
                }
            }
            var response = orderDetailsAPICall(orderDetailsRequest);
            response.then(function (data) {
                if (data) {
                    setOrderDetailsData(data);
                }
            });
        }
    }, [orderHistoryLoaded, dateSelectorValue]);
    return {
        orderDetailsData: orderDetailsData,
        orderDetailsError: orderDetailsError,
        orderDetailsLoaded: orderDetailsLoaded,
    };
};
var generateRequestData = function (customerType, orderNumber, timezone, registerNumber, salesDate, storeNumber, transactionId, transactionType) {
    var filteredOrderNumber = orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber.find(function (order) { return (order === null || order === void 0 ? void 0 : order[0]) !== 'H'; });
    var orderType = getOrderType(filteredOrderNumber);
    var requestData;
    if (customerType === 'b2b' && orderType === 'ONLINE') {
        if (transactionType === 'R') {
            requestData = {
                orderDetailsRequest: {
                    searchType: 'online',
                    registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                    salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                    storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                    transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                    transactionType: transactionType !== null && transactionType !== void 0 ? transactionType : '',
                    orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                    customerAccountId: getSvocId() || '',
                    groupAndSortBy: {
                        groupBy: 'fulfillmentType',
                        filterResponse: true,
                    },
                    timezone: timezone,
                },
            };
            return requestData;
        }
        requestData = {
            orderDetailsRequest: {
                searchType: 'online',
                orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                customerAccountId: getSvocId() || '',
                groupAndSortBy: {
                    groupBy: 'fulfillmentType',
                    filterResponse: true,
                },
                timezone: timezone,
            },
        };
        return requestData;
    }
    if (orderType === 'INSTORE') {
        requestData = {
            orderDetailsRequest: {
                searchType: 'instore',
                registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                customerAccountId: getSvocId() || '',
                groupAndSortBy: {
                    groupBy: 'fulfillmentType',
                    filterResponse: true,
                },
                timezone: timezone,
            },
        };
        return requestData;
    }
    requestData = {
        orderDetailsRequest: {
            searchType: orderType === null || orderType === void 0 ? void 0 : orderType.toLowerCase(),
            orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
            timezone: timezone,
        },
    };
    return requestData;
};
